import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComplaintSuggestionService } from 'src/app/modules/complaints-suggestions/_services/complaints-suggestions.service';
import { catchError } from 'rxjs/operators';
import { HotToastService } from '@ngneat/hot-toast';
import { CaptchaService } from '../_services/CaptchaService.service';
import { SafeUrlPipe } from '../safeUrl.pipe';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss'],
  providers: [SafeUrlPipe],

})
export class CareerComponent implements OnInit, OnDestroy {
  language: any;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = [];
  formGroup: FormGroup;
  MobilePattern = "(5)[0-9]{8}";
  NoWhitespacePattern = "^([\u0621-\u064A]+ )+[\u0621-\u064A]+$|^[\u0621-\u064A]+$|^([a-zA-Z]+ )+[a-zA-Z]+$|^[a-zA-Z]+$";
  IDPattern = /^(?=\D*\d)(?=\w{10}$)[\da-zA-Z]*$/;
  captchaCode: string;
  userInput: string = '';
  isValid: boolean | undefined;
  CVattachment;
  Photoattcahment;
  MedicalAuthorityattchament;
  constructor(private ComplaintSuggestionService: ComplaintSuggestionService,private fb: FormBuilder,
     private SafeUrlPipe: SafeUrlPipe, private translationService: TranslationService,private toast: HotToastService,private captchaService: CaptchaService) { }
   
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.loadForm();
    this.captchaCode = this.captchaService.getCaptchaCode();
    this.isLoading$ = this.ComplaintSuggestionService.isLoading$;
  }
  refreshCaptcha() {
    this.captchaService.generateCaptcha();
    this.captchaCode = this.captchaService.getCaptchaCode();
    this.isValid = undefined;
  }

  validateCaptcha() {
    this.isValid = this.captchaService.validateCaptcha(this.userInput);
  }
 
  loadForm() {

    this.formGroup = this.fb.group({
      Id: [0],
      Sepciality: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      nationality: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      gender: ['', Validators.required],
      fullName: ['', [Validators.required,Validators.pattern(this.NoWhitespacePattern)]],
      email:['',Validators.required],
      mobile:  ['', [Validators.required,Validators.pattern(this.MobilePattern)]],
      photo: '',
      cv: '',
      medicalAuthority: '',
    });
  }
  submit()
  {
    this.formGroup.markAllAsTouched();
    if (!this.formGroup.valid) {
      return;
    }
    const formValues = this.formGroup.value;
    formValues.cv = this.CVattachment;
    formValues.photo = this.Photoattcahment;
    formValues.medicalAuthority = this.MedicalAuthorityattchament;
    if (!formValues.cv)
    {
      if (this.language == "ar") {
        this.toast.warning("<b> يجب تحميل السيرة الذاتية </b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>You must upload your CV</b>", { style: { padding: '20px' } });
      }
      return
    }
    this.ComplaintSuggestionService.showLoader();
    const Subscr = this.ComplaintSuggestionService.AddCareer(formValues).pipe(
      catchError((errorMessage) => {
        this.ComplaintSuggestionService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
  
      if (res.isSuccess && res.responseCode == 200) {
        
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.ComplaintSuggestionService.hideLoader();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
     
      }
      else if (res.isSuccess && res.responseCode == 404) {
        this.toast.warning("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.ComplaintSuggestionService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.ComplaintSuggestionService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.ComplaintSuggestionService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.ComplaintSuggestionService.hideLoader();

      }
    });
    this.subscriptions.push(Subscr);

  }
  AddCVAttachment(event , Type) {
   
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (Type == "CV")
      {
        
        if (!this.CheckCVFileValidation(event.target.files[0])) {
          return;
        }
        this.CVattachment = reader.result as string;
      }
      if (Type == "Photo")
        {
          
          if (!this.CheckPhotoFileValidation(event.target.files[0])) {
            return;
          }
          this.Photoattcahment =  reader.result as string;
        }
      if (Type == "MedicalAuthority")
        {
          
          if (!this.CheckMedicalAuthorityFileValidation(event.target.files[0]) && Type == "MedicalAuthority") {
            return;
          }
          this.MedicalAuthorityattchament =  reader.result as string;
        }
    }
  }
  CheckPhotoFileValidation(file: File) {
    let extension = file.name.split('.').pop();
    extension = extension.toLocaleLowerCase();
    if (extension != "jpg" && extension != "png" && extension != "jpeg") {
      this.toast.error("<b>صيغة الملف غير مسموح بها</b>", { style: { padding: '20px' } });
      return false;
    }
    if (file.size == 0 || file.size > 2097152) {
      this.toast.error("<b>لا يمكن تحميل الملف بسبب حجمه كبير</b>", { style: { padding: '20px' } });
      return false;
    } 
    return true;
  }
  CheckCVFileValidation(file: File) {
    let extension = file.name.split('.').pop();
    extension = extension.toLocaleLowerCase();
    if (extension != "pdf" && extension != "docx") {
      this.toast.error("<b>صيغة الملف غير مسموح بها</b>", { style: { padding: '20px' } });
      return false;
    }
    if (file.size == 0 || file.size > 2097152) {
      this.toast.error("<b>لا يمكن تحميل الملف بسبب حجمه كبير</b>", { style: { padding: '20px' } });
      return false;
    } 
    return true;
  }
  CheckMedicalAuthorityFileValidation(file: File) {
    let extension = file.name.split('.').pop();
    extension = extension.toLocaleLowerCase();
    if (extension != "pdf" ) {
      this.toast.error("<b>صيغة الملف غير مسموح بها</b>", { style: { padding: '20px' } });
      return false;
    }
    if (file.size == 0 || file.size > 2097152) {
      this.toast.error("<b>لا يمكن تحميل الملف بسبب حجمه كبير</b>", { style: { padding: '20px' } });
      return false;
    } 
    return true;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string) {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
